import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";

const useStyles = makeStyles({
  container: {
    width: "237px",
    height: "237px",
    background: "#E6E6E6E5",
    borderRadius: "50%",
    position: "fixed",
    left: "calc(50% - 115px)",
    top: "calc(50% - 115px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    zIndex: 30001,
  },
  number: {
    fontSize: "128px",
  },
  text: {
    fontSize: "51px",
  },
});

// interface AudioRecordingCountdownProps {
//   onStart: proptypes.func,
//   readyToBegin: proptypes.bool,
//   state: proptypes.oneOf(["idle", "preparing", "recording"]),
// };

export default function AudioRecordingCountdown(props) {
  const [count, setCount] = useState(3);
  const { state, readyToBegin, onStart } = props;

  const classes = useStyles();

  useEffect(() => {
    if (count === 1 && !readyToBegin) {
      return;
    }

    if (count >= 0) {
      const timeout = setTimeout(() => setCount(count - 1), 1000);
      return () => clearTimeout(timeout);
    }
  }, [readyToBegin, count]);

  useEffect(() => {
    if (count === 0) {
      onStart();
    }
  }, [count]);

  useEffect(() => {
    if (state === "preparing") {
      setCount(3);
    }
  }, [state]);

  if (count < 0) {
    return null;
  }

  return (
    <div className={classes.container}>
      <span className={count > 0 ? classes.number : classes.text}>{count > 0 ? count : "Begin!"}</span>
    </div>
  );
}
